/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIToggle from 'UIComponents/input/UIToggle';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIExpandingTextArea from 'UIComponents/input/UIExpandingTextArea';
import UICharacterCounter from 'UIComponents/counters/UICharacterCounter';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { GROUP } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { INLINE_HELP_TEXT, REQUIRED, LOCKED, EXPANDED } from 'DesignData/enums/CustomWidgetFieldAttributes';
import FormControlWithErrors from 'DesignEditorsUI/components/customWidgetEditor/sidebar/FormControlWithErrors';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import BorderSidesToggle from 'DesignEditorsUI/components/customWidgetEditor/sidebar/fieldEdit/BorderSidesToggle';
import withDebouncedInput from 'DesignEditorsUI/components/shared/inputs/withDebouncedInput';
const DebouncedUICharacterCounter = withDebouncedInput(UICharacterCounter);

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.editorOptions.${key}`;

export default class _class extends Component {
  constructor(...args) {
    super(...args);

    this.onHelpTextChange = e => {
      this.props.editField({
        help_text: e.target.value
      });
    };

    this.onInlineHelpTextChange = e => {
      this.props.editField({
        [INLINE_HELP_TEXT]: e.target.value
      });
    };

    this.onRequiredChange = e => {
      this.props.editField({
        [REQUIRED]: e.target.checked
      });
    };

    this.onLockedChange = e => {
      this.props.editField({
        [LOCKED]: e.target.checked
      });
    };

    this.onExpandedChange = e => {
      this.props.editField({
        [EXPANDED]: e.target.checked
      });
    };

    this.renderRequiredToggle = () => {
      const {
        field,
        readOnly
      } = this.props;

      if (field.type === GROUP) {
        return null;
      }

      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UIFormLabel, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('requiredLabel')
          })
        }), /*#__PURE__*/_jsx(UIToggle, {
          checked: field[REQUIRED],
          "data-test-id": "module-field-editor-options-required-toggle",
          onChange: this.onRequiredChange,
          size: "extra-small",
          readOnly: readOnly
        })]
      });
    };

    this.renderLockedToggle = () => {
      if (this.props.isGlobal) {
        return null;
      }

      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UIFormLabel, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('lockedLabel')
          })
        }), /*#__PURE__*/_jsx(UIToggle, {
          checked: this.props.field[LOCKED],
          "data-test-id": "module-field-editor-options-locked-toggle",
          onChange: this.onLockedChange,
          size: "extra-small",
          readOnly: this.props.readOnly
        })]
      });
    };

    this.renderExpandedToggle = () => {
      const {
        field,
        readOnly
      } = this.props;
      if (field.type !== GROUP) return null;
      const containsNestedGroups = field.children.some(child => child.type === GROUP);
      if (containsNestedGroups) return null;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(UIFormLabel, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('expandedLabel')
          })
        }), /*#__PURE__*/_jsx(UIToggle, {
          checked: field[EXPANDED],
          "data-test-id": "module-field-editor-options-expanded-toggle",
          onChange: this.onExpandedChange,
          size: "extra-small",
          readOnly: readOnly
        })]
      });
    };

    this.renderInlineHelpTextInput = () => {
      const {
        field,
        fieldErrors,
        readOnly
      } = this.props;
      return /*#__PURE__*/_jsx(DebouncedUICharacterCounter, {
        counter: "down",
        max: 400,
        onChange: this.onInlineHelpTextChange,
        value: field[INLINE_HELP_TEXT],
        renderInput: ({
          count,
          onChange,
          value
        }) => {
          return /*#__PURE__*/_jsx(FormControlWithErrors, {
            characterCount: count,
            "data-test-id": "module-field-editor-inline-help",
            errors: fieldErrors[INLINE_HELP_TEXT],
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('inlineHelpTextLabel')
            }),
            tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('inlineHelpTextTooltip')
            }),
            children: /*#__PURE__*/_jsx(SidebarInput, {
              disabled: readOnly,
              inputComponent: UIExpandingTextArea,
              minHeight: 70,
              onChange: onChange,
              value: value
            })
          });
        }
      });
    };
  }

  render() {
    const {
      editField,
      field,
      readOnly,
      isV1
    } = this.props;

    const helpTextInput = /*#__PURE__*/_jsx(DebouncedUICharacterCounter, {
      counter: "down",
      max: 300,
      onChange: this.onHelpTextChange,
      value: field.help_text,
      renderInput: ({
        count,
        onChange,
        value
      }) => {
        const isTooLong = count < 0;
        return /*#__PURE__*/_jsx(UIFormControl, {
          characterCount: count,
          "data-test-id": "module-field-editor-tooltip-help",
          error: isTooLong,
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('helpTextLabel')
          }),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('helpTextTooltip')
          }),
          validationMessage: isTooLong && /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey('helpTextLengthWarning')
          }),
          children: /*#__PURE__*/_jsx(SidebarInput, {
            disabled: readOnly,
            inputComponent: UIExpandingTextArea,
            minHeight: 70,
            onChange: onChange,
            value: value
          })
        });
      }
    });

    if (isV1) {
      return /*#__PURE__*/_jsx(ToolFieldset, {
        children: helpTextInput
      });
    }

    return /*#__PURE__*/_jsxs(ToolFieldset, {
      children: [this.renderRequiredToggle(), this.renderLockedToggle(), this.renderExpandedToggle(), helpTextInput, this.renderInlineHelpTextInput(), /*#__PURE__*/_jsx(BorderSidesToggle, {
        editField: editField,
        field: field
      })]
    });
  }

}
_class.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  fieldErrors: PropTypes.object,
  isGlobal: PropTypes.bool,
  readOnly: PropTypes.bool,
  isV1: PropTypes.bool.isRequired
};